module.exports = __webpack_public_path__ + "media/images/categories/carousel/employment-e6d61c09801c6223707b29b5f280ab36.jpg";